/**
 * PEARSON PROPRIETARY AND CONFIDENTIAL INFORMATION SUBJECT TO NDA
 * Copyright © 2025 Pearson Education, Inc. All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains
 * the property of Pearson Education, Inc. The intellectual and technical concepts contained
 * herein are proprietary to Pearson Education, Inc. and may be covered by U.S. and Foreign Patents,
 * patent applications, and are protected by trade secret or copyright law.
 * Dissemination of this information, reproduction of this material, and copying or distribution of this software
 * is strictly forbidden unless prior written permission is obtained
 * from Pearson Education, Inc.
 */

/**
 * Course configuration service
 *
 * @file CourseConfigurationService.js
 * @author Gladson Samuel S
 */


import Framework, { BaseService } from '@greenville/framework';
import {
  COURSE_CONFIGURATION_REQUESTED,
  HTTP_REQUEST_METHODS,
  COURSE_CONFIGURATION_FAILED,
  COURSE_CONFIGURATION_FETCHED
} from '../../../common/constants';

export default class CourseConfigurationService extends BaseService {
  constructor() {
    super(COURSE_CONFIGURATION_REQUESTED, 'courseconfigurationstatus');
  }

  /**
   * Handles course configuration service event
   *
   * @param {*} eventName
   * @param {*} eventData
   * @returns
   */
  handleEvent(eventName, eventData) {
    const {
      method = HTTP_REQUEST_METHODS.GET,
      payload,
      courseId
    } = eventData;

    let response = null;

    switch (method) {
      case HTTP_REQUEST_METHODS.PATCH:
        response = this.getClient('marin')
          .patch(`/courses/${courseId}/configuration`, payload);
        break;
      default:
        response = this.getClient('marin').get(`/courses/${courseId}/configuration`);
        break;
    }

    return response;
  }

  /**
   * Handles course configuration service response
   *
   * @param {*} response
   */
  // eslint-disable-next-line class-methods-use-this
  handleResponse(response, event) {
    if (event?.method === HTTP_REQUEST_METHODS.PATCH) {
      const { callback } = event;

      if (typeof callback === 'function') {
        callback();
      }

      const herobanner = Framework.getStoreRegistry().getStore('herobanner');
      herobanner.fetchCourseSettings(true);
      return;
    }

    const { data } = response;
    const bookshelf = Framework.getStoreRegistry().getStore('bookshelf');
    bookshelf.setCourseConfiguration(data, event.courseId);

    Framework.getEventManager().publish(COURSE_CONFIGURATION_FETCHED, {
      data
    });
  }

  /**
   * Handles book collection service error
   *
   * @param {*} response
   */
  // eslint-disable-next-line class-methods-use-this
  handleError(error, event = {}) {
    event?.onError?.();
    Framework.getEventManager().publish(COURSE_CONFIGURATION_FAILED, error);
    // eslint-disable-next-line no-console
    console.log(error, 'Course configuration service error');
  }
}
